<i *ngIf="phxPrefixIcon" phx-icon class="phx-tag-upsell-prefix" [phxIcon]="phxPrefixIcon" [size]="16" color="currentColor"></i>
<span class="phx-tag-upsell-content"><ng-content></ng-content></span>
